var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('el-button',{on:{"click":_vm.play}},[_vm._v("播放")]),_c('el-button',{on:{"click":_vm.pause}},[_vm._v("暂停")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }